import { faCheck, faMinus } from "@fortawesome/pro-regular-svg-icons";
import { useContext, useMemo } from "react";
import { useTranslation } from "../../../i18n/useTranslation";
import { clearOptionValue } from "../../styledSelect/components/selectStore";
import { USelectContext } from "../context/context";
import { renderOptionDefault, renderSingleOptionDefault } from "../renders/default";
import { optionsIsSame } from "../utils/utils";
const addSelectAllOption = ({ options, value, onChange, label, }) => {
    if (options.length === 0) {
        return options;
    }
    const count = value?.length || 0;
    const allSelected = options.length === count &&
        options.every((opt) => value?.find((valueOpt) => optionsIsSame(valueOpt, opt)));
    const option = {
        label,
        value: "__select_all__",
        active: count > 0 || allSelected,
        render: renderOptionDefault,
        onClick: () => onChange?.(count ? [] : [...options]),
        icon: allSelected ? faCheck : faMinus,
    };
    return [option, ...options];
};
const addClearOption = ({ value, options, onChange, label, }) => {
    if (options.length === 0 || value?.length === 0) {
        return options;
    }
    return [
        {
            label,
            value: clearOptionValue,
            onClick: () => onChange?.([]),
            render: renderSingleOptionDefault,
        },
        ...options,
    ];
};
export const useUSelectOptions = ({ options, value, onChange, clearOption, selectAllOption, onCreate, }) => {
    const { t } = useTranslation();
    const { debounceSearch, immediatelySetSearch } = useContext(USelectContext);
    return useMemo(() => {
        let _options = options || [];
        const loweSearch = debounceSearch.toLowerCase();
        if (debounceSearch &&
            onCreate &&
            !options?.find((opt) => opt.searchString?.toLowerCase() === loweSearch)) {
            _options = [
                {
                    onClick: () => {
                        onCreate(debounceSearch);
                        immediatelySetSearch("");
                    },
                    value: "__create__",
                    label: "Create " + debounceSearch,
                    render: renderSingleOptionDefault,
                },
                ..._options,
            ];
        }
        if (selectAllOption) {
            _options = addSelectAllOption({
                onChange,
                options: _options,
                value,
                label: t("ultraSelect.selectAllOption"),
            });
        }
        if (clearOption) {
            _options = addClearOption({
                onChange,
                options: _options,
                value,
                label: typeof clearOption === "boolean" ? t("ultraSelect.noneOption") : clearOption,
            });
        }
        return _options;
    }, [
        clearOption,
        debounceSearch,
        immediatelySetSearch,
        onChange,
        onCreate,
        options,
        selectAllOption,
        t,
        value,
    ]);
};
